import { takeEvery, put, call } from 'redux-saga/effects';
import { npcLogConstant } from 'src/redux/actions/constant';
import npcLogService from 'src/services/apiServices/npcLogService/npcLogService';

function* addNpcEntry(action: any): any {
  try {
    yield put({ type: npcLogConstant.ADD_NPC_ENTRY_LOADER });
    // THIN-8187: a reviewer creating on behalf of a therapist sends a therapistUuid — route that
    // through the APPROVE_NPC-gated /for-therapist endpoint. A therapist's own add has no
    // therapistUuid and stays on the self-attributed POST.
    const createFor = action.payload?.therapistUuid
      ? npcLogService.addNpcEntryForTherapist
      : npcLogService.addNpcEntry;
    const response = yield call(createFor, action.payload);
    // create returns 201; edit/list return 200 — accept either.
    if (response?.status === 200 || response?.status === 201) {
      yield put({
        type: npcLogConstant.ADD_NPC_ENTRY_SUCCESS,
        payload: { response: response.data, status: response?.status },
      });
    } else {
      throw response;
    }
  } catch (error: any) {
    yield put({
      type: npcLogConstant.ADD_NPC_ENTRY_FAILURE,
      payload: { response: error?.response?.data, status: error?.response?.status },
    });
  }
}

function* addNpcEntrySaga() {
  yield takeEvery(npcLogConstant.ADD_NPC_ENTRY_REQUEST, addNpcEntry);
}

export default addNpcEntrySaga;
